export default {
  resources: {
    badge: 'Recursos y centro de conocimiento',
    title: 'Todos los recursos',
    subtitle: 'Casos de éxito, guías prácticas y tendencias del sector para optimizar la entrega y las operaciones de flota.',
    successStories: 'Casos de éxito',
    successStoriesSub: 'Resultados reales de equipos de entrega reales',
    learning: 'Formación',
    learningSub: 'Artículos, whitepapers y guías',
    stats: {
      caseStudies: 'Casos de éxito',
      blogArticles: 'Artículos del blog',
      whitepapers: 'Whitepapers',
    },
    ctaTitle: '¿Listo para ver Geofleet en acción?',
    ctaSubtitle: 'Empieza ya o reserva una demo para obtener resultados similares en tus operaciones.',
    ctaTrial: 'Empezar',
    ctaDemo: 'Reservar demo',
    explore: 'Explorar',
    howItWorks: {
      title: 'Cómo funciona',
      subtitle: 'Fácil de navegar, rápido para encontrar lo que necesitas',
    },
    whatsInside: {
      badge: 'Lo que encontrarás',
      title: 'Todo lo que ofrece {{name}}',
    },
    whyItMatters: {
      title: 'Por qué importa',
      subtitle: 'Datos clave sobre {{name}}',
    },
    cta: {
      exploreTitle: '¿Listo para explorar {{name}}?',
      exploreSubtitle: 'Empieza en minutos. Planes desde $49 al mes para 3 conductores.',
    },
  },
};
